export default __webpack_public_path__ + "static/media/Shared-Image-ARTIGOS-SYS-10.03f09f83.png";